import { Tabs, message } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { TeamProjectDetailTable } from './team-project-detail-table.component'
import { TeamSpecificProjectDetailTable } from './team-specific-project-detail-table.component'

export const TeamDetailDashboard = React.forwardRef<{ download: () => void }, { departmentId: number }>(
  ({ departmentId }, ref) => {
    const { t } = useTranslation()

    const startDate = new URLSearchParams(window.location.search).get('startDate')
    const endDate = new URLSearchParams(window.location.search).get('endDate')

    React.useImperativeHandle(ref, () => {
      return {
        download() {
          if (!startDate || !endDate) {
            message.warn('起始或截止日期不存在')
            return
          }
          const a = document.createElement('a')
          const params = new URLSearchParams()
          params.append('startDate', startDate)
          params.append('endDate', endDate)
          params.append('departmentId', departmentId.toString())
          a.href = `/api/work-resource/statistics/team/detail/download?${params.toString()}`
          document.body.appendChild(a)
          a.click()
          a.remove()
        },
      }
    }, [startDate, endDate, departmentId])

    return (
      <Tabs destroyInactiveTabPane>
        <Tabs.TabPane tab={t('dashboard.table.specificProject')} key='specific-project'>
          <TeamSpecificProjectDetailTable departmentId={departmentId} />
        </Tabs.TabPane>
        <Tabs.TabPane tab={t('dashboard.table.normalProject')} key='project'>
          <TeamProjectDetailTable departmentId={departmentId} />
        </Tabs.TabPane>
      </Tabs>
    )
  }
)
